const Point = () => {
  return (
    <>
      <div className="comingSoon">Coming Soon</div>
      <h2>ポイント管理（全ショップ合計）</h2>

      <h4>サマリ</h4>
      <div className="listSummary">
        <ul>
          <li>
            <div className="title">総ポイント</div>
            <div className="data">150<span>P</span></div>
          </li>
        </ul>
      </div>

      <h4>ユーザー一覧（サイゼ品川店）</h4>

      <div className="tableDataList">
        <table>
          <tbody>
            <tr>
              <th>id</th>
              <th>nickname</th>
              <th>point</th>
              <th>history</th>
              <th>edit</th>
            </tr>
            <tr>
              <td>
                1
              </td>
              <td>
                smaresMaru1
              </td>
              <td>
                30
              </td>
              <td>
                ポイント使用履歴を見る
              </td>
              <td>
                ポイントを編集する
              </td>
            </tr>
            <tr>
              <td>
                2
              </td>
              <td>
                smaresMaru2
              </td>
              <td>
                30
              </td>
              <td>
                ポイント使用履歴を見る
              </td>
              <td>
                ポイントを編集する
              </td>
            </tr>
            <tr>
              <td>
                3
              </td>
              <td>
                smaresMaru3
              </td>
              <td>
                30
              </td>
              <td>
                ポイント使用履歴を見る
              </td>
              <td>
                ポイントを編集する
              </td>
            </tr>
            <tr>
              <td>
                4
              </td>
              <td>
                smaresMaru4
              </td>
              <td>
                30
              </td>
              <td>
                ポイント使用履歴を見る
              </td>
              <td>
                ポイントを編集する
              </td>
            </tr>
            <tr>
              <td>
                5
              </td>
              <td>
                smaresMaru5
              </td>
              <td>
                ポイント使用履歴を見る
              </td>
              <td>
                ポイントを編集する
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
export default Point;